import { connect } from 'react-redux';
import * as React from 'react';
import { bindActionCreators } from 'redux';
import * as toastr from 'toastr';

import pickListActions from './pickListActions';
import { Page, PageContent, PageHeader } from '../../components/common';
import PickListTypeList from './PickListTypeList';

import { SecurityRoles } from '../../common/utils';
import { ensureUserHasRole } from '../../auth/authComponents';

interface Props {
	actions: any;
	history: any;
	pickListTypes: Array<PickListItem>;
}
class PickListTypeListPage extends React.Component<Props, any> {
	componentWillMount() {
		this.props.actions.getPickListTypes();
	}

	EditPickList = (pickListId: string) => {
		this.props.history.push(`/admin/pick-lists/${pickListId}`);
	}
	DeletePickList = (pickListId: string) => {
		toastr.error('NOT IMPLEMENTED');
	}

	render() {
		const { pickListTypes } = this.props;
		return (
			<Page title="Pick list types">
				<PageContent>
					<PageHeader title="Pick list types" />
					<PickListTypeList
						pickListTypes={pickListTypes}
						OnEdit={this.EditPickList}
						OnDelete={this.DeletePickList}
						history={this.props.history}
					/>
				</PageContent>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		pickListTypes: state.pickList.types
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...pickListActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const ConnectedPickListTypePage = connect(mapStateToProps, mapDispatchToProps)(PickListTypeListPage);
export default ensureUserHasRole(ConnectedPickListTypePage as any, [SecurityRoles.Administrator, SecurityRoles.Agent]);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/PickList/PickListTypeListPage.tsx